export default () => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '1rem',
  },
})
